import moment from "moment";
import { useEffect, useState } from "react";
import { Cell } from "react-table";
import { useApiOperation } from "src/api/hooks";
import { PageMeta } from "src/api/public-types";
import { getQuestionListAsync } from "src/api/question/qeustion-api";
import { QuestionListModel } from "src/api/question/question-type";
import { BaseTooltip } from "src/components";
import BaseSelectTable from "src/components/BaseSelectTable";
import { PagePath } from "src/pages/product/details";
import { siteOptions, statusOptions } from "src/pages/question/question-types";
import { YmdFormat } from "src/utils/common-util";
import BaseNewTabLink from "../BaseNewTabLink";
import useCsData from "src/pages/question/useCsData";

const columns: any = [
  {
    Header: "id",
    accessor: "id",
    width: 80,
    Cell: ({ value }: { value?: string }) => {
      if (!value) {
        return "-";
      }
      return <BaseNewTabLink path={PagePath.provider.detail.replace(":id", value)} value={value} className="ml16" />;
    },
  },
  {
    Header: "상태",
    accessor: "status",
    width: 80,
    Cell: ({ value }: Cell<QuestionListModel>) => {
      let status = statusOptions.find((option) => option.value === value)?.label;
      let color = statusOptions.find((option) => option.value === value)?.tagColor;

      return <span className={color}>{status}</span>;
    },
  },

  {
    Header: "유입경로",
    accessor: "site",
    width: 120,
    Cell: ({ value }: Cell<QuestionListModel>) => {
      const site = siteOptions.find((data) => data.value === value)?.label;
      return <span className="text-center text-leftw-100">{site || "-"}</span>;
    },
  },
  {
    Header: "구분",
    accessor: "csCategoryType",
    width: 80,
  },
  {
    Header: "유형",
    accessor: "csTypeName",
    width: 120,
    Cell: ({ value }: Cell<QuestionListModel>) => {
      return <span>{value || "-"}</span>;
    },
  },
  {
    Header: "항목",
    accessor: "summary",
    width: 160,
    Cell: ({ value }: Cell<QuestionListModel>) => {
      return <BaseTooltip className="text-left w-100" contents={value || "-"}></BaseTooltip>;
    },
  },
  {
    Header: "접수 내용",
    accessor: "description",
    width: 160,
    Cell: ({ value }: Cell<QuestionListModel>) => {
      return <BaseTooltip className="text-left w-100" contents={value || "-"}></BaseTooltip>;
    },
  },
  {
    Header: "접수일시",
    accessor: "createdDate",
    width: 120,
    Cell: ({ value }: Cell<QuestionListModel>) => {
      return <BaseTooltip contents={moment(value).format(YmdFormat.YYYY_MM_DD_HH_MM)} type="date" />;
    },
  },
  {
    Header: "건물명",
    accessor: "buildingName",
    width: 120,
    Cell: ({ value }: Cell<QuestionListModel>) => {
      return <BaseTooltip isSingleLine={false} className="text-left w-full" contents={value ?? "-"} />;
    },
  },
  {
    Header: "세부 위치",
    accessor: "floorNum",
    width: 120,
    Cell: ({ value }: Cell<QuestionListModel>) => {
      return (
        <BaseTooltip className="text-left w-100" contents={value ? (value > 0 ? `지상${value}층` : `지하${Math.abs(value)}층`) : "-"}></BaseTooltip>
      );
    },
  },
  {
    Header: "접수자 신청/계약",
    accessor: "contractName",
    width: 160,
    Cell: ({ value }: Cell<QuestionListModel>) => {
      //연결된 신청/계약이 있는 경우 계약명 출력, 없으면 하이픈 출력
      //계약명 정보 없으면 '상품명' 출력
      return <BaseTooltip className="text-left w-100" contents={value || "-"}></BaseTooltip>;
    },
  },
  {
    Header: "접수자명",
    accessor: "reporterName",
    width: 120,
    Cell: ({ value }: Cell<QuestionListModel>) => {
      //CS 문의 정보 > 이름/닉네임 출력
      return <BaseTooltip className="text-left w-100" contents={value || "-"}></BaseTooltip>;
    },
  },
];
type Props = {
  partnerId?: string; //TODO: 필요 없으면 관련코드 제거 해주세요.
  onClick?: (data: string[]) => void;
  onClose?: () => void;
  defaultCheckedList?: string[];
};

const SelectCsListPopup = ({ partnerId, onClick, onClose, defaultCheckedList }: Props) => {
  const [Questions, setQuestions] = useState<Array<QuestionListModel>>([]);
  const [pageMeta, setPageMeta] = useState<PageMeta>();
  const [defaultDisabledList, setDefaultDisabledList] = useState<string[]>();

  const [params, setParams] = useState({
    page: 0,
    size: 20,
    keywordList: "",
    sort: {
      orders: [
        {
          property: "id",
          direction: "DESC",
        },
      ],
    },
  });

  const { detailedQuestionList, questionListMeta } = useCsData({ questionQueryParams: params });
  useEffect(() => {
    setQuestions(detailedQuestionList);
    setPageMeta(questionListMeta?.pageMeta);
  }, [detailedQuestionList, questionListMeta]);

  return (
    <BaseSelectTable
      setParams={setParams}
      defaultDisabledList={defaultDisabledList} // 현 or 다른 CS 에 연결된 워크오더는 선택 못하게 처리
      defaultCheckedList={defaultCheckedList}
      title="CS 선택"
      selectKey={"id"}
      columns={columns}
      data={Questions ?? []}
      checkboxType={"checkbox"}
      onClick={(checkedKeyList) => onClick && onClick(checkedKeyList)}
      onClose={() => onClose && onClose()}
      pageMeta={pageMeta}
      searchInputProps={{
        searchOptionList: [
          { value: "", label: "전체" },
          { value: "SUMMARY", label: "항목" },
        ],

        onSearch(value, searchOption) {
          setParams((prev) => ({ ...prev, page: 0, keywordList: value, searchType: searchOption }));
        },
      }}
      minLength={1}
    />
  );
};

export default SelectCsListPopup;
